export default __webpack_public_path__ + "static/form-builder-a59308c185de82c0f8eae761e921aff6.png";